import { produce } from 'immer';
import { TemplateState } from '../templateeditor-types';
import {
  AiTemplateBuilderAction,
  TEMPLATE_EDITOR_AI_ANALYZE_REQUEST,
  TEMPLATE_EDITOR_AI_ANALYZE_TRACKED,
  TEMPLATE_EDITOR_AI_APPLY_CHECKBOX_GROUPING,
  TEMPLATE_EDITOR_AI_APPLY_FIELD_SUGGESTION,
  TEMPLATE_EDITOR_AI_SAVED_WITH_AI_FIELDS_SUCCESS,
  TEMPLATE_EDITOR_AI_SETUP_EXISTING_METRICS
} from './actions';
import { applyCheckboxFieldGrouping, applyFieldSuggestions } from './updaters';
import { setIsDirty } from '../updaters';
import { incrememtSaveCount, markAsTracked, addExistingMetrics, trackAnalysis } from './updaters-analytics';

export function aiTemplateBuilderReducer(state: TemplateState, action: AiTemplateBuilderAction): TemplateState {
  return produce(state, (draft) => {
    switch (action.type) {
      case TEMPLATE_EDITOR_AI_SETUP_EXISTING_METRICS:
        // don't dirty, just set up the AI metrics
        return addExistingMetrics(draft, action.payload);

      case TEMPLATE_EDITOR_AI_ANALYZE_REQUEST:
        // no need to dirty since we're just setting analyzing states for tracking
        return trackAnalysis(draft);

      case TEMPLATE_EDITOR_AI_APPLY_FIELD_SUGGESTION:
        return setIsDirty(applyFieldSuggestions(draft, action.payload));

      case TEMPLATE_EDITOR_AI_APPLY_CHECKBOX_GROUPING:
        return setIsDirty(applyCheckboxFieldGrouping(draft));

      case TEMPLATE_EDITOR_AI_SAVED_WITH_AI_FIELDS_SUCCESS:
        // don't diry, just increment the save count
        return incrememtSaveCount(draft);

      case TEMPLATE_EDITOR_AI_ANALYZE_TRACKED:
        // don't dirty, just mark the AI metrics as tracked
        return markAsTracked(draft);

      default:
        return draft;
    }
  });
}
